<template>
  <div>
    <el-dialog title="注文書の自動読取範囲検出" :visible.sync="showModal">
      <el-checkbox-group
          v-model="checkedDetect"
          @change="updateDetect"
      >
        <el-checkbox style="margin-left: 0" border
                     class="ml-0 mr-5 mb-5"
                     size="medium"
                     v-for="(detect, index) in detectList"
                     :label="detect.id" :key="index">
          {{ detect.title }}
        </el-checkbox>
      </el-checkbox-group>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveCheckedDetect">検出</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
export default {
  name: "AutoDetect",
  props: ["autoDetectVisible"],
  data() {
    return {
      checkedDetect: [],
      showModal: false
    };
  },
  watch: {
    autoDetectVisible: function (newVal) {
      this.showModal = newVal;
    }
  },
  computed: {
    ...mapState({
      detectList: state => state.detect.detects,
      autoDetectResult: state => state.detect.auto_detects,
      template: state => state.template.template
    }),
  },
  methods: {
    ...mapActions('detect', ['getDetectBox']),
    ...mapActions(['loading']),
    updateDetect(value) {
      this.checkedDetect = value;
    },
    async saveCheckedDetect() {
      this.loading(true);
      let data = {id: this.$route.params.id, fields: this.checkedDetect};
      this.showModal = false;
      await this.getDetectBox(data);
      this.loading(false);
      this.$emit("set-detect-box", this.autoDetectResult);
      this.checkedDetect = [];
      this.$router.push({
        path: `/templates/${this.template.id}`,
      });
    }
  }
}
</script>

<style scoped>

</style>